import {createStore, compose, applyMiddleware } from 'redux';
import {reactReduxFirebase, getFirebase} from 'react-redux-firebase';
import thunk from 'redux-thunk';

import rootReducer from './rootReducer';
import firebase from "../util/fire";
import promiseMiddleware from '../util/promiseMiddleware';

function configureStoreDev(initialState) {
    const middleware = [
        thunk.withExtraArgument(getFirebase),
        promiseMiddleware
    ];

    // react-redux-firebase config
    const rrfConfig = {
        userProfile: 'users'
    };

    const createStoreWithFirebase = compose(
        applyMiddleware(...middleware),
        reactReduxFirebase(firebase, rrfConfig)
    )(createStore);

    return createStoreWithFirebase(rootReducer, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
}

export default configureStoreDev;


// WEBPACK FOOTER //
// ./src/store/configureStore.js